import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useSelector } from '../redux/store';
import type { RootState } from '../redux/store';
import { PATH_DASHBOARD } from '../routes/paths';

export default function OrgMemberGuard({ children }: { children: ReactNode }) {
  const { memberships, activeOrgGuid, isLoading } = useSelector(
    (s: RootState) => s.organizationContext
  );

  if (isLoading) return null;

  const isMember = !!activeOrgGuid && memberships.some((m) => m.organizationGuid === activeOrgGuid);

  if (!isMember) {
    return <Navigate to={PATH_DASHBOARD.overview.root} replace />;
  }

  return <>{children}</>;
}
